import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  isOpen: false,
};

export const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    toogleMenu: (state) => {
      state.isOpen = !state.isOpen;
    },
  },
});
export const { toogleMenu } = menuSlice.actions;
export default menuSlice.reducer;
